import { AddOrderMediaFields, OrderMedia } from '@insurance/components'
import { Text } from '@shared/components'
import { Flex } from 'antd'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  orderId?: string | number
}

export const OrderMediaActions = ({ orderId }: Props) => {
  const { t } = useTranslation()
  const [disabledFileGet, setDisabledFileGet] = useState(false)

  // const { data: order } = useSalesServiceSalesOrdersRetrieve(
  //   { id: Number(orderId) },
  //   undefined,
  //   { enabled: !!orderId }
  // )

  return (
    <>
      <Flex align="center" gap={8} justify="space-between">
        <Text size={16} strong>
          {t('attachment_files')}
        </Text>

        {/* <AssignInspector order={order} /> */}
      </Flex>

      <OrderMedia orderId={orderId} disabledFileGet={disabledFileGet} />

      <AddOrderMediaFields
        orderId={orderId}
        onDisabledFileGet={setDisabledFileGet}
      />
    </>
  )
}
